import { PropsWithChildren } from 'react';

const MainContentWrapper = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <div
      style={{
        maxWidth: '1012px',
        margin: '32px auto',
      }}
    >
      <>{children}</>
    </div>
  );
};

export default MainContentWrapper;
